import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useLanguage } from '../../../../contexts/LanguageContext';
import LmsCodeMultiSelect from '../../components/LmsCodeMultiSelect';

const VehicleTrainingMatchTable = ({ items, totalCount, loading, lazyParams = { first: 0, rows: 10 }, filters, sortField, sortOrder, onPage, onFilter, onSort, onEdit }) => {
    const { th } = useLanguage();
    const trainingFilterTemplate = (options) => (
        <LmsCodeMultiSelect groupCode="TRAINING_TYPES" value={options.value} onChange={(value) => options.filterApplyCallback(value)} placeholder={th('vehicleTrainingMatch.selectTraining')} className="p-column-filter w-full" closeOnChange />
    );

    return (
        <DataTable
            value={items}
            totalRecords={totalCount}
            className="p-datatable-gridlines"
            showGridlines
            lazy
            paginator
            filterDisplay="row"
            filters={filters}
            onFilter={onFilter}
            first={lazyParams?.first ?? 0}
            rows={lazyParams?.rows ?? 10}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            onPage={onPage}
            loading={loading}
            dataKey="vehicleCode"
            emptyMessage={th('common.noRecords')}
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={onSort}
            sortMode="single"
        >
            <Column body={(row) => <i className="pi pi-pencil cursor-pointer text-blue-500 hover:text-blue-700" title={th('common.edit')} onClick={() => onEdit(row)} />} style={{ width: '4rem', textAlign: 'center' }} frozen />
            <Column field="vehicleName" header={th('vehicleTrainingMatch.vehicleModel')} sortable filter filterPlaceholder={th('vehicleTrainingMatch.vehicleModel')} body={(row) => row.vehicleName ?? '-'} />
            <Column field="trainingName" header={th('vehicleTrainingMatch.trainingType')} sortable filter filterElement={trainingFilterTemplate} body={(row) => row.trainings?.map(({ name }) => name).join(', ') || '-'} />
            <Column field="isActive" header={th('common.status')} sortable body={(row) => (row.isActive ? th('common.active') : th('common.inactive'))} />
        </DataTable>
    );
};

export default VehicleTrainingMatchTable;
